var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircleIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon check-circle-icon",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "gray"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.475 4.818a.5.5 0 01.765.64l-.048.057-5.5 5.667a.502.502 0 01-.669.044l-.056-.052L3.8 8.84a.5.5 0 01.679-.731l.054.05 1.808 1.948 5.134-5.289z"
  })));
}

export default SvgCheckCircleIconSv;